import { Configuration, RetailersApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import PageHeader from '@/components/PageHeader';
import { RetailerCreate, RetailerUpdate } from '@/models/Retailer';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import RetailerForm from '@/modules/admin/components/RetailerForm';
import { RetailerListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const RetailerAdd = () => {
  const navigate = useNavigate();

  const retailersApi = new RetailersApi(new Configuration(useAuth));

  const handleOnSubmit = async (retailer: RetailerCreate | RetailerUpdate): Promise<void> => {
    try {
      await retailersApi.createRetailer(retailer);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Retailer "${retailer.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(RetailerListPath);
    } catch (error) {
      console.error('Failed to create retailer:', error);
    }
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Create Retailer" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <RetailerForm onSubmit={handleOnSubmit} />
      </div>
    </>
  );
};

export default RetailerAdd;
